import { useSelector } from 'react-redux'
import { Grid } from '@mui/material'

import Select from '../Select'
import { useSelectionSet } from '../../hooks/selection-set-functions'

const SelectRitardo = () => {
  const availableRitardi = useSelector(
    state => state.selection.availableRitardi,
  )
  const selectedRitardo = useSelector(state => state.selection.selectedRitardo)

  const { setSelectedRitardo } = useSelectionSet()

  const value = availableRitardi?.includes(selectedRitardo)
    ? selectedRitardo
    : undefined

  return (
    <Grid size={{ xs: 12, md: 2 }}>
      <Select
        id='available-ritardi'
        label='Ritardo'
        value={value}
        options={availableRitardi}
        disabled={!availableRitardi}
        onChange={setSelectedRitardo}
      />
    </Grid>
  )
}

export default SelectRitardo
